/** Participant statuses excluded from catering counts (summary, catalog base, headers). */
export const CATERING_EXCLUDED_PARTICIPANT_STATUSES = new Set([
  'waitlist',
  'cancellation',
  'not_participant',
  'cancelled',
  'afbud',
]);

export function shouldCountParticipantForCatering(
  status: string | null | undefined
): boolean {
  const normalized = (status ?? '').trim().toLowerCase();
  return !CATERING_EXCLUDED_PARTICIPANT_STATUSES.has(normalized);
}

export function countParticipantsForCatering<
  T extends { status?: string | null }
>(items: T[] | null | undefined): number {
  return (items ?? []).filter((item) =>
    shouldCountParticipantForCatering(item.status)
  ).length;
}
